const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_dynamicLayout/c/$spaceSlug/$postSlug.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const postSlugSearchSchema = z.object({
  payment_success: z.boolean().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_dynamicLayout/c/$spaceSlug/$postSlug")({
  validateSearch: postSlugSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});